module.exports = __webpack_public_path__ + "img/relocation.f40b0e66.svg";